var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"help",attrs:{"title":_vm.$t('help.title'),"color":"accent","fixed":"","fab":"","large":"","bottom":"","right":""},on:{"click":_vm.help}},[_c('v-icon',[_vm._v("mdi-help")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }